import apiClient from './client';

export const statsApi = {
  getStats: async () => {
    const response = await apiClient.get('/api/v1/stats');
    return response.data;
  },
};
